import NumberSelect from 'src/design/components/formSelect/NumberSelect';

const MonthOfYearSelect = ({ ...props }) => <NumberSelect {...props} min={1} max={12} defaultValueText="MM"/>;

export default MonthOfYearSelect;
